import { getIntegrationData } from './integrationStorage';
const HTTP_BAD_REQUEST = 400;
const BUSINESS_ERROR_CODE = 'BUSINESS_ERROR';
const PENDING_REGISTRATION_DATA_ERRORS = new Set(['REQUEST_VALIDATION_ERROR', 'INTEGRATION_VALUES_NOT_FOUND']);
function isNonEmptyString(value) {
    return value !== null && value !== undefined && value.trim() !== '';
}
export function isValidCompanyId(companyId) {
    return isNonEmptyString(companyId);
}
export function isValidClientId(clientId) {
    return isNonEmptyString(clientId);
}
export function canContractBillingProduct(entityId) {
    if (!entityId) {
        return false;
    }
    const integrationData = getIntegrationData(entityId);
    if (!integrationData) {
        return false;
    }
    const { companyId, clientId } = integrationData;
    const isCompanyIdValid = isValidCompanyId(companyId);
    const isClientIdValid = isValidClientId(clientId);
    return isCompanyIdValid && isClientIdValid;
}
export function isPendingRegistrationDataError(error) {
    if (!error || typeof error !== 'object') {
        return false;
    }
    const { status, details, data } = error;
    const result = (details ?? data)?.result;
    return (status === HTTP_BAD_REQUEST &&
        result?.errorCode === BUSINESS_ERROR_CODE &&
        PENDING_REGISTRATION_DATA_ERRORS.has(result?.error ?? ''));
}
